/**
 * @generated SignedSource<<18aa41874ffe78ef75bf18e15652c590>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
export type BuildBlockedStates = "FAILED" | "PASSED" | "RUNNING" | "%future added value";
export type BuildStates = "BLOCKED" | "CANCELED" | "CANCELING" | "CREATING" | "FAILED" | "FAILING" | "NOT_RUN" | "PASSED" | "RUNNING" | "SCHEDULED" | "SKIPPED" | "%future added value";
import type { FragmentType } from "relay-runtime";
declare export opaque type Status_pipeline$fragmentType: FragmentType;
export type Status_pipeline$data = {|
  +firstBuild: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +blockedState: ?BuildBlockedStates,
        +state: BuildStates,
        +url: string,
      |},
    |}>,
  |},
  +id: string,
  +$fragmentType: Status_pipeline$fragmentType,
|};
export type Status_pipeline$key = {
  +$data?: Status_pipeline$data,
  +$fragmentSpreads: Status_pipeline$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Status_pipeline",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": "firstBuild",
      "args": [
        {
          "kind": "Literal",
          "name": "branch",
          "value": "%default"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "BuildConnection",
      "kind": "LinkedField",
      "name": "builds",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BuildEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Build",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "state",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "blockedState",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "builds(branch:\"%default\",first:1)"
    }
  ],
  "type": "Pipeline",
  "abstractKey": null
};

(node/*: any*/).hash = "ef87fcebb3747467bcaf02e49d4de5f9";

module.exports = ((node/*: any*/)/*: Fragment<
  Status_pipeline$fragmentType,
  Status_pipeline$data,
>*/);
